import { Injectable } from '@angular/core';

// google analytics service
@Injectable()
export class GaService {

  addSearch(searchTerm){
    (<any>window).dataLayer.push({
      'search': {
        'form' : 'quickSearch',
        'type' : 'keyword',
        'term' : searchTerm,
        'state' : '',
        'city' : '',
        'county' : ''
      },
      'event' : 'searchSubmit'
    });
  }

  addNavigationClick(filterClicked){
    (<any>window).dataLayer.push({
      'navigation': {
        'type' : 'searchRefinement',
        'menuItem' : filterClicked,
      },
      'event' : 'navigationClick'
    });
  }

  addProfileFilterClick(filterClicked){
    (<any>window).dataLayer.push({
      'navigation': {
        'type' : 'profileRefinement',
        'menuItem' : filterClicked,
      },
      'event' : 'navigationClick'
    })
  }

  addSideBarClick(){
    (<any>window).dataLayer.push({
      'navigation': {
        'type' : 'dashboardNav',
        'menuItem' : 'DashBoard',
      },
      'event' : 'navigationClick'
    })
  }

  addUserProfileClick(){
    (<any>window).dataLayer.push({
      'navigation': {
        'type' : 'accountManagement',
        'menuItem' : 'menu',
      },
      'event' : 'navigationClick'
    })
  }

  addAdvancedSearch(searchType, searchTerm, state, citiesSelected, countiesSelected){
    (<any>window).dataLayer.push({
      'search': {
        'form' : 'primarySearch',
        'type' : searchType,
        'term' : searchTerm,
        'state' : state,
        'city' : citiesSelected,
        'county' : countiesSelected
      },
      'event' : 'searchSubmit'
    });
  }

  addSearchResultClick(profileName, type, isMember){
    (<any>window).dataLayer.push({
      'serpClick' : {
        'profileName' : profileName,
        'profileType' : type,
        'isMember' : isMember,
        'isSearchResult': 'true'
      },
      'event': 'serpClick'
    });
  }

  addPersonSearchResultClick(profileName, type){
    (<any>window).dataLayer.push({
      'serpClick' : {
        'profileName' : profileName,
        'profileType' : type,
        'isMember' : '',
        'isSearchResult': 'true'
      },
      'event': 'serpClick'
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/common/services/ga.service.ts